var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHomework = function SvgHomework(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 14 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3d96ff",
    d: "M5.188 14.438V9.055a1.5 1.5 0 0 1 .44-1.086 1.43 1.43 0 0 1 1.06-.452h4.5a1.5 1.5 0 0 1 .44-1.087 1.43 1.43 0 0 1 1.06-.451q.618 0 1.059.451a1.5 1.5 0 0 1 .44 1.087v6.92h-3.75v-3.075q0-.326-.215-.548a.72.72 0 0 0-.534-.221.72.72 0 0 0-.535.22.75.75 0 0 0-.216.549v3.076zm-4.5 0v-8.94q0-.48.262-.875.262-.393.694-.567L9.425 1a.68.68 0 0 1 .694.077.74.74 0 0 1 .319.635V5.98h-4.5q-.938 0-1.594.673a2.25 2.25 0 0 0-.657 1.634v6.152z"
  })));
};
export default SvgHomework;